import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight, Mail } from "lucide-react";
import { CTA } from "@/constants/testIds";

export default function CTASection() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [60, -60]);

  return (
    <section
      ref={ref}
      id="contact"
      data-testid={CTA.section}
      className="relative py-20 md:py-40"
    >
      <div className="aurora bg-[#0A84FF] h-[300px] w-[300px] md:h-[500px] md:w-[500px] left-1/2 -translate-x-1/2 top-10 opacity-30" />
      <div className="max-w-[1100px] mx-auto px-5 sm:px-6 md:px-10 text-center relative">
        <motion.p
          style={{ y }}
          className="text-[11px] md:text-xs font-bold uppercase tracking-[0.3em] text-[#0A84FF] mb-6"
        >
          Let&apos;s build
        </motion.p>
        <h2 className="font-display text-[14vw] sm:text-6xl md:text-7xl lg:text-[9vw] font-black tracking-[-0.04em] leading-[0.9] text-grad">
          Have an idea?<br />
          <span className="italic shimmer">Let&apos;s ship it.</span>
        </h2>
        <p className="mt-6 md:mt-8 text-[#a1a1a6] text-sm sm:text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
          Tell us what you&apos;re building. We&apos;ll come back within one business day with a senior team and a clear plan.
        </p>
        <div className="mt-8 md:mt-10 flex flex-wrap items-center justify-center gap-3 md:gap-4">
          <a
            href="mailto:contact@jdtechnologies.co"
            data-testid={CTA.emailLink}
            className="btn-glow inline-flex items-center gap-2 rounded-full bg-white text-black px-5 sm:px-8 py-3 sm:py-4 text-sm md:text-lg font-bold tracking-tight break-all max-w-full"
          >
            <Mail size={16} strokeWidth={2.5} className="flex-none" />
            <span className="truncate">contact@jdtechnologies.co</span>
            <ArrowUpRight size={16} strokeWidth={2.5} className="flex-none" />
          </a>
        </div>
        <p className="mt-6 text-xs text-[#6b6b70] tracking-wider">
          Replies within 24 hours · NDA on request · Worldwide
        </p>
      </div>
    </section>
  );
}
